import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'

import { Paths } from '@/common/utils'

import AppToolbar from '../../AppBar/AppToolbar'

const classes = {
    root: {
        backgroundColor: 'background.paper',
        borderRadius: 1,
        border: (theme) => `1px ${theme.palette.grey[300]} solid`,
        width: '100%',
        height: 'calc(100vh - 154px)',
        gap: 3,
    },

    notFoundImage: {
        width: '542px',
    },
    notFoundMessage: {
        gap: 1,
    },
}

const NotFound = () => {
    const { t } = useTranslation()

    const navigate = useNavigate()

    return (
        <>
            <AppToolbar />
            <Grid
                component="section"
                size={12}
                container
            >
                <Box
                    sx={[
                        {
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            p: 12,
                        },
                        classes.root,
                    ]}
                >
                    <Box
                        alt="Not Found"
                        component="img"
                        src="404.svg"
                        sx={classes.notFoundImage}
                    />

                    <Box
                        sx={[
                            {
                                alignItems: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                            },
                            classes.notFoundMessage,
                        ]}
                    >
                        <Typography variant="h4">{t('Page not found')}</Typography>
                        <Typography variant="body1">{t("We can't find the page you're looking for.")}</Typography>
                    </Box>

                    <Button
                        color="primary"
                        size="large"
                        variant="contained"
                        onClick={() => navigate(Paths.HOME_PATHNAME)}
                    >
                        Back to Home
                    </Button>
                </Box>
            </Grid>
        </>
    )
}

export default NotFound
